export default [
    {
        type: "selection",
        width: 38,
        align: "center",
    },
    {
        title: 'Assigned Users',
        key: 'UserName',
        minWidth: 80,
    },

]
